module.exports = __webpack_public_path__ + "Icon_Global Outlook@2x.png?fb4b859eee2ab90918b508a21bfc19b9";